function imageObject(key, ext, width, height) {
  return {
    thumb: {
      url: require(`../images/${key}_thumb.${ext}`),
      width: width / 2,
      height: height / 2,
    },
    full: {
      url: require(`../images/${key}.${ext}`),
      width: width,
      height: height,
    }
  }
}

const data = {
  filters: {
    month: [],
    trend: [],
    colour: [],
  },
  sections: {
    intro: {
      heading: "What the World Wanted to Wear",
      text: "<p>This year 80 million shoppers from 120 countries started their fashion search on Lyst. We tracked more than 100 million searches; crunching the queries, page views and sales data across 5 million fashion products from 12,000 designers and stores. From Gucci to gingham, sneakers to sequins, Lyst’s data reveals what you wanted to wear in 2017.</p>",
    },
    trending: {
      heading: "Trending Now",
      terms: [
        {
          label: "Moncler jackets",
          url: "https://www.lyst.com/shop/moncler-jackets/"
        },
        {
          label: "Hoop earrings",
          url: "https://www.lyst.com/shop/trends/hoop-earrings/"
        },
        {
          label: "Gucci bags",
          url: "https://www.lyst.com/shop/gucci-shoulder-bags/"
        },
        {
          label: "Saint Laurent boots",
          url: "https://www.lyst.com/shop/saint-laurent-boots/"
        },
        {
          label: "Needle & Thread dresses",
          url: "https://www.lyst.com/shop/needle-thread-dresses/"
        },
        {
          label: "RE/DONE jeans",
          url: "https://www.lyst.com/shop/redone-jeans/"
        },
        {
          label: "Gucci belts",
          url: "https://www.lyst.com/shop/gucci-belts/"
        },
        {
          label: "Balenciaga sneakers",
          url: "https://www.lyst.com/shop/mens-balenciaga-sneakers/"
        },
        {
          label: "Ear cuffs",
          url: "https://www.lyst.com/shop/trends/ear-cuff-chain-earrings/"
        },
        {
          label: "Acne Canada scarves",
          url: "https://www.lyst.com/shop/trends/acne-canada/"
        },
        {
          label: "Yeezy boots",
          url: "https://www.lyst.com/shop/mens-yeezy-boots/"
        },
        {
          label: "Off White sweats",
          url: "https://www.lyst.com/shop/mens-off-white-co-virgil-abloh-sweats/"
        },
        {
          label: "Guidi boots",
          url: "https://www.lyst.com/shop/mens-guidi-boots/"
        },
        {
          label: "Common Projects Sneakers",
          url: "https://www.lyst.com/shop/mens-common-projects-sneakers/"
        },
        {
          label: "Winter coats",
          url: "https://www.lyst.com/shop/trends/wool-coats/"
        },
        {
          label: "Bucket bags",
          url: "https://www.lyst.com/shop/trends/jw-anderson-bucket/"
        },
        {
          label: "Faux fur coats",
          url: "https://www.lyst.com/shop/trends/faux-fur-coats/"
        },
        {
          label: "Velvet dresses",
          url: "https://www.lyst.com/shop/trends/velvet-dresses/"
        },
        {
          label: "Leopard print shoes",
          url: "https://www.lyst.com/shop/trends/leopard-print-shoes/"
        },
        {
          label: "Sock boots",
          url: "https://www.lyst.com/shop/trends/heeled-sock-boots/"
        },
        {
          label: "Chloe Perry shoes",
          url: "https://www.lyst.com/shop/trends/chloe-perry/"
        },
        {
          label: "Shearling coats",
          url: "https://www.lyst.com/shop/trends/mens-shearling-coats/"
        },
        {
          label: "Chelsea boots",
          url: "https://www.lyst.com/shop/trends/mens-chelsea-boots/"
        },
        {
          label: "Levis 501s",
          url: "https://www.lyst.com/shop/trends/mens-levis-501/"
        },
        {
          label: "Stutterheim Raincoats",
          url: "https://www.lyst.com/shop/trends/mens-stutterheim-stockholm/"
        },
        {
          label: "Lace-Up Bodysuits",
          url: "https://www.lyst.com/shop/trends/lace-up-bodysuits/"
        },
        {
          label: "Puff-Sleeved Dresses",
          url: "https://www.lyst.com/shop/trends/puff-sleeved-dresses/"
        },
        {
          label: "Pleated Mini Skirts",
          url: "https://www.lyst.com/shop/trends/pleated-midi-skirts/"
        },
        {
          label: "Ruffle Sweaters",
          url: "https://www.lyst.com/shop/trends/ruffle-sweaters/"
        },
        {
          label: "Gingham Shirts",
          url: "https://www.lyst.com/shop/trends/gingham-shirts/"
        },
        {
          label: "Valentino Guitar Bags",
          url: "https://www.lyst.com/shop/trends/valentino-guitar/"
        },
        {
          label: "Gucci Lilith Bags",
          url: "https://www.lyst.com/shop/trends/gucci-lilith/"
        },
        {
          label: "Indah Beachwear",
          url: "https://www.lyst.com/shop/indah-beachwear/"
        },
        {
          label: "IRO Clay T-shirts",
          url: "https://www.lyst.com/shop/trends/iro-clay/"
        },
        {
          label: "Ruffle Slides",
          url: "https://www.lyst.com/shop/trends/ruffle-slides/"
        },
        {
          label: "Medallion Necklaces",
          url: "https://www.lyst.com/shop/trends/medallion-necklaces/"
        },
      ]
    },
    topTen: {
      lists: [
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "Big Brands, Big Logos, Big Trends",
          navHeading: "Trends",
          intro: "<p>In an eventful year, fashion went big and bold. Gucci’s maximalism, power tailoring and woke slogans made 2017 a year of statement style. These 10 trends were the overarching fashion themes of the year, each one accounting for millions of searches split across thousands of key items.</p>",
          items: [
            {
              label: "Gucci-ish",
              shortLabel: null,
              image: imageObject('trends/Gucci-ish', 'png', 786, 846),
              caption: "Alessandro Michele’s Gucci was the biggest brand of 2017- searched for by more than 35 million shoppers on Lyst this year. When does one designer’s aesthetic go beyond a logo and become a global trend? When alongside searches for specific Gucci pieces, people are searching for trademark Gucci touches- loud florals, clashing prints, snakes, embroidery, embellishment, green and red stripes.",
              month: "February",
              trend: null,
              type: "image",
            },
            {
              label: "Logos",
              shortLabel: null,
              image: imageObject('trends/Logos', 'png', 798, 707),
              caption: "Logo pieces were amongst the most wanted products this year for Balenciaga, Gucci, Loewe and Saint Laurent. Retro sports brands Champion, Fila and Kappa made a huge fashion comeback- together searches for these three brands increased 460% year on year.",
              month: "January",
              trend: null,
              type: "image",
            },
            {
              label: "Woke Fashion",
              shortLabel: null,
              image: imageObject('trends/Woke', 'png', 481, 580),
              caption: "Searches for slogan (not including logo) t-shirts increased 105% this year, with many designers choosing to embrace feminist or political messaging. In a year of change, customers looked to fashion to express themselves.",
              month: "January",
              trend: null,
              type: "image",
            },
            {
              label: "Elevated Streetwear",
              shortLabel: null,
              image: imageObject('trends/Streetwear', 'png', 1040, 1300),
              caption: "Cult items by Off-White, Balenciaga and Vetements were amongst the most wanted fashion pieces of 2017.",
              month: "June",
              trend: null,
              type: "image",
            },
            {
              label: "Jetleisure",
              shortLabel: null,
              image: imageObject('trends/Jetleisure', 'png', 390, 585),
              caption: "In June Lyst identified a new luxury clothing category, comprised of items bought specifically to feature in your most aspirational holiday Instagram stories. Bright, fun pieces by Zimmerman, Mara Hoffman, Eugenia Kim, Dodo Bar Or and Melissa Odabash sold out all summer long.",
              month: "June",
              trend: null,
              type: "image",
            },
            {
              label: "70s",
              shortLabel: null,
              image: imageObject('trends/70s', 'png', 1040, 1300),
              caption: "Flares, mustard, pussy bow blouses and cord all came through for 2017. Disco glitter boots were a popular Fall party dressing accessory, and searches for sequins increased 42% from June to November.",
              month: "November",
              trend: null,
              type: "image",
            },
            {
              label: "80s",
              shortLabel: null,
              image: imageObject('trends/80s', 'png', 1040, 1300),
              caption: "Yeezy, Off-White and The Kardashians brought back 80s cycling shorts this year. Searches rose 79% year on year.",
              month: "September",
              trend: null,
              type: "image",
            },
            {
              label: "90s",
              shortLabel: null,
              image: imageObject('trends/90s', 'png', 1040, 1300),
              caption: "From crop tops to chainmail, spaghetti straps to slip dresses, Lyst saw a number of decidedly 90s search terms this year. Doc Martens boots and Spice Girl inspired chunky platform shoes were amongst the most wanted styles for Fall.",
              month: "August",
              trend: null,
              type: "image",
            },
            {
              label: "Deconstructed",
              shortLabel: null,
              image: imageObject('trends/Deconstructed', 'png', 1040, 1300),
              caption: "Searches including the word ‘deconstructed’ peaked in July. Jacquemus and Vetements’ deconstructed shirts, and their many copycat versions, were the most wanted product for this trend.",
              month: "March",
              trend: null,
              type: "image",
            },
            {
              label: "Power Tailoring",
              shortLabel: null,
              image: imageObject('trends/Tailoring', 'png', 1040, 1300),
              caption: "Sharp suiting made a comeback this year, with a 68% increase in searches for blazers (grey plaid being the most popular) and a 24% increase in searches for women’s suits. Red and pink suiting both spiked in September.",
              month: "November",
              trend: null,
              type: "image",
            }
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "Instagram-Famous Bags",
          navHeading: "Handbags",
          intro: "<p>Instantly recognisable and available in a huge selection of colours and patterns, Gucci’s Marmont purses, belt bags and cross-bodies were the most wanted bags of the year. These were 2017’s hottest handbags, based on Lyst’s global search and sales data.</p>",
          items: [
            {
              label: "Gucci Marmont",
              shortLabel: null,
              image: imageObject('products/bags/gg-marmont-floral-jacquard-shoulder-bag-LYST', 'png', 878, 605),
              caption: "Searches for the Marmont collection spiked 102% following February fashion month.",
              month: "June",
              trend: ["Logo","Gucci-ish"],
              type: "image",
            },
            {
              label: "J.W Anderson Pierce",
              shortLabel: null,
              image: imageObject('products/bags/J-W-Anderson-Black-Small-Velvet-Pierce-Shoulder-Bag-Lyst', 'png', 657, 771),
              caption: "The most popular bag of 2016, demand continued for new sizes and fabrics in 2017.",
              month: "January",
              trend: null,
              type: "image",
            },
            {
              label: "Chloe Nile",
              shortLabel: null,
              image: imageObject('products/bags/Chloe-Gray-Nile-Bracelet-Small-Cross-body-Bag-Lyst', 'png', 572, 815),
              caption: "The bag on everyone’s arm at September Paris Fashion Week.",
              month: "September",
              trend: null,
              type: "image",
            },
            {
              label: "Cult Gaia Ark",
              shortLabel: null,
              image: imageObject('products/bags/Cult-Gaia-Multicolor-Gaias-Ark-Bag-Lyst', 'png', 468, 443),
              caption: "Summer’s most wanted Insta-trophy bag.",
              month: "August",
              trend: null,
              type: "image",
            },
            {
              label: "Gucci Dionysus",
              shortLabel: null,
              image: imageObject('products/bags/Gucci-Dionysus', 'png', 980, 980),
              caption: "Lyst saw a Dionysus search once every 6 seconds in the fall.",
              month: "June",
              trend: ["Logo","Gucci-ish"],
              type: "image",
            },
            {
              label: "Dior J’adior",
              shortLabel: null,
              image: imageObject('products/bags/christian-dior-spring-2017-jadior-flap-bag', 'png', 2866, 3781),
              caption: "The Dior J’adior shot to the most searched for bag following it’s release in February. It received over 35,000 searches in its first week online.",
              month: "March",
              trend: ["Logo"],
              type: "image",
            },
            {
              label: "Balenciaga Arena",
              shortLabel: null,
              image: imageObject('products/bags/Balenciaga-Gray-Arena-Leather-Shopper-Lyst', 'png', 758, 714),
              caption: "The Arena Shopper was a street style favourite. Searches peaked in April.",
              month: "April",
              trend: null,
              type: "image",
            },
            {
              label: "Loewe Elephant",
              shortLabel: null,
              image: imageObject('products/bags/Loewe-Pink-Elephant-Mini-Leather-Shoulder-Bag-Lyst', 'png', 645, 541),
              caption: "Searches for the Loewe Elephant spiked 307% in January.",
              month: "January",
              trend: null,
              type: "image",
            },
            {
              label: "Simon Miller Bonsai",
              shortLabel: null,
              image: imageObject('products/bags/Simon-Miller-Multicolor-S801-Bonsai-15-Cm-Lyst', 'png', 398, 610),
              caption: "Saw 9,000 searches a week in Spring.",
              month: "April",
              trend: null,
              type: "image",
            },
            {
              label: "Off-White Binder Clip",
              shortLabel: null,
              image: imageObject('products/bags/Off-White-c-o-Virgil-Abloh-Yellow-Binder-Clip-Saffiano-Leather-Bag-Lyst', 'png', 565, 474),
              caption: "Virgil Abloh’s most popular accessory of 2017.",
              month: "November",
              trend: ["Logo","Streetwear"],
              type: "image",
            }
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "New Shapes in Shoes",
          navHeading: "Shoes",
          intro: "<p>Sliding straight in at first and second positions on the hottest shoes list, flat pool slide sandals were the year’s breakaway shoe trend. Lyst saw more searches for slides than stilettos this summer- across all price points. Fall’s most wanted shoe trend was the ankle length sock boot, driven by designers Vetements and Balenciaga.</p>",
          items: [
            {
              label: "Gucci GG Blooms Supreme Slides",
              shortLabel: null,
              image: imageObject('products/shoes/Gucci-Multicolor-Gg-Blooms-Supreme-Slide-Sandal-Lyst', 'png', 790, 326),
              caption: "These slides were the top selling product on Lyst over the summer.",
              month: "July",
              trend: ["Gucci-ish"],
              type: "image",
            },
            {
              label: "Givenchy Logo Slides",
              shortLabel: null,
              image: imageObject('products/shoes/Givenchy-Black-Logo-Slides-Lyst', 'png', 855, 301),
              caption: "The Givenchy logo slides were searched for once every 7 seconds between April and July.",
              month: "April",
              trend: ["Logo", "Woke"],
              type: "image",
            },
            {
              label: "Vetements Sock Boots",
              shortLabel: null,
              image: imageObject('products/shoes/Vetements-Green-Unicorn-Heel-Sock-Ankle-Boots-Lyst', 'png', 596, 839),
              caption: "Searches for Vetements boots were up 56% year on year and their sock boots were the most popular.",
              month: "March",
              trend: ["80s"],
              type: "image",
            },
            {
              label: "Balenciaga Knife Boots",
              shortLabel: null,
              image: imageObject('products/shoes/Balenciaga-Red-Knife-Bootie-Lyst', 'png', 450, 440),
              caption: "Balenciaga’s most wanted shoe style this year.",
              month: "May",
              trend: ["Elevate", "Streetwear"],
              type: "image",
            },
            {
              label: "Gucci Princeton Loafer",
              shortLabel: null,
              image: imageObject('products/shoes/Gucci-Metallic-Princeton-Slide-Loafers-Lyst', 'png', 665, 375),
              caption: "A winter favourite in 2016, their popularity remained steady throughout 2017.",
              month: "October",
              trend: ["Gucci-ish"],
              type: "image",
            },
            {
              label: "No21 Leather Bow Mule",
              shortLabel: null,
              image: imageObject('products/shoes/N021-Green-110mm-Bow-Velvet-Mule-Sandals-Lyst', 'png', 637, 643),
              caption: "Searches peaked in August.",
              month: "August",
              trend: ["70s"],
              type: "image",
            },
            {
              label: "Saint Laurent Crystal Boots",
              shortLabel: null,
              image: imageObject('products/shoes/Saint-Laurent-Black-Niki-Swarovski-Crystal-embellished-Leather-Knee-Boots-Lyst', 'png', 553, 862),
              caption: "The Saint Laurent crystal boots sold out within minutes and were viewed more than 45,000 times in October.",
              month: "October",
              trend: null,
              type: "image",
            },
            {
              label: "Mansur Gavriel Mules",
              shortLabel: null,
              image: imageObject('products/shoes/Mansur-Gavriel-Pink-Suede-Mules-Lyst', 'png', 573, 263),
              caption: "Searches for Mansur Gavriel increased 33% year on year, driven by these mules.",
              month: "February",
              trend: ["70s"],
              type: "image",
            },
            {
              label: "Saint Laurent Opyum Pumps",
              shortLabel: null,
              image: imageObject('products/shoes/Saint-Laurent-Black-110mm-Opyum-Logo-Patent-Leather-Pumps-Lyst', 'png', 635, 531),
              caption: "The Opyum pumps were the most searched-for Saint Laurent shoes on Lyst.",
              month: "May",
              trend: ["Logo"],
              type: "image",
            },
            {
              label: "Oscar Tiye Minnie Sandal",
              shortLabel: null,
              image: imageObject('products/shoes/Oscar-Tiye-Black-Minnie-Leather-Sandals-Lyst', 'png', 637, 761),
              caption: "The black Oscar Tiye Minnie Sandals were huge on Instagram.",
              month: "October",
              trend: null,
              type: "image",
            }
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "We Started Saying Goodbye to Skinny Jeans",
          navHeading: "Denim",
          intro: "<p>Lyst saw a denim search every 2 seconds of 2017. While skinny jeans remain the most popular denim item globally, these 5 denim trends all saw significant growth this year, leading us to believe 2018 could be the year straighter styles take over.</p>",
          items: [
            {
              label: "Vintage Look ‘Mom’ Jeans",
              shortLabel: null,
              image: imageObject('denim/Mom-jeans', 'jpg', 1500, 1000),
              caption: "Inspired by vintage fit jeans, the flattering Levi’s Wedgie style in blue was the most wanted pair of jeans worldwide this year, and searches for ‘mom’ jeans are up 109% year on year.",
              month: "October",
              trend: ["80s"],
              type: "image",
            },
            {
              label: "Straight Leg Jeans",
              shortLabel: null,
              image: imageObject('denim/Straight-Leg-Jeans', 'jpg', 1500, 1000),
              caption: "Searches for straight leg denim increased 60% year on year. Jeans by Frame, Acne and Topshop were amongst the most popular styles.",
              month: "April",
              trend: ["90s"],
              type: "image",
            },
            {
              label: "Frayed Hem Denim",
              shortLabel: null,
              image: imageObject('denim/Frayed-Hem', 'jpg', 1500, 1000),
              caption: "Denim searches including the word ‘hem’ increased 240% in 2017. Frayed hem jeans by RE/DONE, Vetements and Mother were the most wanted pairs.",
              month: "March",
              trend: ["Deconstructed"],
              type: "image",
            },
            {
              label: "Embroidered Denim",
              shortLabel: null,
              image: imageObject('denim/Embroidered-Denim', 'jpg', 1500, 1000),
              caption: "Searches for embroidered denim peaked in spring- with embroidered pieces on offer from everyone from Gucci to H&M. Oversized, floral embroidered jean jackets were especially popular in the UK.",
              month: "June",
              trend: ["70s","90s"],
              type: "image",
            },
            {
              label: "Kick Flare and Cropped Kick Flare Jeans",
              shortLabel: null,
              image: imageObject('denim/Cropped-Kick-Flare', 'jpg', 1500, 1000),
              caption: "As seen on street style stars all year, J Brand’s Selena cut was a popular denim search term in spring.",
              month: "May",
              trend: ["70s"],
              type: "image",
            }
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "It Was a Colorful Year",
          navHeading: "Colors",
          intro: "<p>While black, blue, gray and white remained the world’s most popular fashion colors all year round (yawn), these more daring shades saw the most movement in terms of search volume over the last 12 months.</p>",
          items: [
            {
              label: "Red",
              shortLabel: null,
              image: imageObject('colours/Red', 'jpg', 1500, 1000),
              caption: "Searches for red items increased 102% in 2017, driven by searches for red boots and coats in the Fall.",
              month: "September",
              trend: ["70s","Gucci-ish","Tailoring","Jetleisure","Streetwear"],
              type: "image",
            },
            {
              label: "Pink",
              shortLabel: null,
              image: imageObject('colours/Pink', 'jpg', 1500, 1000),
              caption: "From Millennial to fuschia via bubblegum and rosé, there were 19,000 more pink fashion items on Lyst in 2017 than 2016. Searches for pink pieces peaked in March but remained high all year.",
              month: "March",
              trend: ["80s"],
              type: "image",
            },
            {
              label: "Yellow",
              shortLabel: null,
              image: imageObject('colours/yellow', 'jpg', 1500, 1000),
              caption: "Emma Stone’s yellow dress in La La Land boosted searches for all things yellow in January.",
              month: "January",
              trend: ["70s"],
              type: "image",
            },
            {
              label: "Khaki",
              shortLabel: null,
              image: imageObject('colours/khaki', 'jpg', 1500, 1000),
              caption: "Lyst saw a khaki jacket search once every 8 seconds in May. Topshop, J.Crew and Asos were amongst the most popular brands.",
              month: "May",
              trend: ["Woke","Deconstructed"],
              type: "image",
            },
            {
              label: "Nude",
              shortLabel: null,
              image: imageObject('colours/Nude', 'jpg', 1500, 1000),
              caption: "Beige, nude, flesh tone, blush … From lingerie to dresses and shoes, the number of nude items on Lyst increased by 23% in 2017, with global searches for nude pieces up 30% year on year.",
              month: "August",
              trend: ["Woke"],
              type: "image",
            },
            {
              label: "Orange",
              shortLabel: null,
              image: imageObject('colours/Orange-Paris', 'jpg', 1500, 1000),
              caption: "Searches for orange items peaked in September, likely inspired by street style stars wearing orange at Fashion Week shows.",
              month: "September",
              trend: ["Jetleisure","Gucci-ish","Streetwear"],
              type: "image",
            },
            {
              label: "Silver",
              shortLabel: null,
              image: imageObject('colours/Silver', 'jpg', 1500, 1000),
              caption: "Metallic skirts and shoes were popular in the summer. Silver was the most popular metallic shade of the year, replacing gold in 2016.",
              month: "July",
              trend: ["Woke","Deconstructed"],
              type: "image",
            },
            {
              label: "Electric blue",
              shortLabel: null,
              image: imageObject('colours/electric-blue', 'jpg', 1500, 1000),
              caption: "Searches for bright, internet link blue knitwear started trending in November.",
              month: "November",
              trend: ["90s"],
              type: "image",
            },
            {
              label: "Mustard",
              shortLabel: null,
              image: imageObject('colours/Mustard', 'jpg', 1500, 1000),
              caption: "Fall’s new neutral; Lyst saw 3,000 searches a day containing the word ‘mustard’ in October.",
              month: "October",
              trend: ["70s"],
              type: "image",
            },
            {
              label: "Rainbow",
              shortLabel: null,
              image: imageObject('colours/Rainbow', 'jpg', 1500, 1000),
              caption: "2017 started brightly, with searches for rainbow leather accessories by Loewe, Sophie Hulme and Anya Hindmarch spiking in January.",
              month: "January",
              trend: ["70s","90s"],
              type: "image",
            }
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "We Camouflaged Up and Checked Out",
          navHeading: "Fabrics",
          intro: "<p>While simple denim, cotton and wool pieces of course remain hugely popular globally- we saw searches for these specific prints, patterns and fabrics spike this year.</p>",
          items: [
            {
              label: "Gingham",
              shortLabel: false,
              image: imageObject('fabrics-prints/gingham', 'jpg', 1500, 1000),
              caption: "Spring’s most popular print. There were 8,000 searches a day for gingham tops in April.",
              month: "April",
              trend: ["70s","Jetleisure","Deconstructed"],
              type: "image",
            },
            {
              label: "Velvet",
              shortLabel: false,
              image: imageObject('fabrics-prints/Velvet', 'jpg', 1500, 1000),
              caption: "Trending all year round across clothes and accessories, velvet ankle boots were the most popular velvet item of 2017.",
              month: "October",
              trend: ["80s","Tailoring"],
              type: "image",
            },
            {
              label: "Dark florals",
              shortLabel: false,
              image: imageObject('fabrics-prints/Dark-florals-Milan-day1', 'jpg', 1500, 1000),
              caption: "Big beyond Spring. Groundbreaking.",
              month: "February",
              trend: ["70s","Tailoring","Gucci-ish"],
              type: "image",
            },
            {
              label: "Plaid",
              shortLabel: false,
              image: imageObject('fabrics-prints/Plaid', 'jpg', 1500, 1000),
              caption: "A key trend during the September fashion shows, plaid blazers overtook shirts as the most wanted checked item this year.",
              month: "September",
              trend: ["80s","Tailoring"],
              type: "image",
            },
            {
              label: "Palm print",
              shortLabel: false,
              image: imageObject('fabrics-prints/PALM-PRINT', 'jpg', 1500, 1000),
              caption: "Searches for leafy, tropical palm prints peaked in July.",
              month: "July",
              trend: ["70s","90s"],
              type: "image",
            },
            {
              label: "Wicker",
              shortLabel: false,
              image: imageObject('fabrics-prints/Wicker-basket-London3', 'jpg', 1500, 1000),
              caption: "Wicker basket bags began trending in April and sold out all summer long.",
              month: "May",
              trend: ["70s","Jetleisure"],
              type: "image",
            },
            {
              label: "Fishnet",
              shortLabel: false,
              image: imageObject('fabrics-prints/FISHNET', 'jpg', 1500, 1000),
              caption: "Searches for fishnet socks and stockings surged in March.",
              month: "March",
              trend: ["90s","Deconstructed"],
              type: "image",
            },
            {
              label: "Camo",
              shortLabel: false,
              image: imageObject('fabrics-prints/Camo-NYC-17', 'jpg', 1500, 1000),
              caption: "More than 4000 camouflage items were available through Lyst this year.",
              month: "June",
              trend: ["70s","90s","Streetwear"],
              type: "image",
            },
            {
              label: "Vinyl",
              shortLabel: false,
              image: imageObject('fabrics-prints/Vinyl-London-SS18', 'jpg', 1500, 1000),
              caption: "There were 114% more searches for ‘vinyl’ in 2017 than 2016.",
              month: "January",
              trend: ["90s"],
              type: "image",
            },
            {
              label: "Corduroy",
              shortLabel: false,
              image: imageObject('fabrics-prints/Corduroy-SS18-Milan', 'jpg', 1500, 1000),
              caption: "October kicked off a corduroy comeback, driven by searches for Gucci and Prada.",
              month: "November",
              trend: ["70s"],
              type: "image",
            }
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "editorial",
          heading: "The Moments That Made You Search",
          navHeading: "Moments",
          intro: "<p>It’s no surprise that Netflix shows, blockbuster movies, cultural events and viral social media moments got you searching for fashion items this year. We analysed spikes in global fashion search following some of the most talked-about moments of 2017.</p>",
          items: [
            {
              label: "Rompergate",
              shortLabel: null,
              image: imageObject('moments-searching/Rompers', 'jpg', 1600, 1000),
              caption: "In May some bros gained global attention by launching a men’s RompHim romper suit on Kickstarter. Searches for men’s rompers increased 620% in the 2 months that followed- and traffic to Mr Turk’s short men’s jumpsuits increased 5x.",
              month: null,
              trend: null,
              type: "image",
            },
            {
              label: "The Return of Baywatch",
              shortLabel: null,
              image: imageObject('moments-searching/v1', 'jpg', 1200, 813),
              caption: "The most popular swimwear style of the summer was the scoop cut 90s one-piece swimsuit, coinciding with the film’s release. Searches for red swimsuits increased 200% year on year.",
              month: "July",
              trend: ["90s"],
              type: "image",
            },
            {
              label: "Remembering Diana",
              shortLabel: null,
              image: imageObject('moments-searching/PrincessDiana', 'jpg', 2000, 1333),
              caption: "August 2017 marked the 20th anniversary of Princess Diana’s death, and the world’s media payed homage to her most iconic looks. Lyst saw searches for 80s style off the shoulder black mini dresses, leopard print swimsuits and mom jeans spike as her style choices influenced us all over again. Virgil Abloh’s Diana-inspired Off-White collection at Paris Fashion Week marked peak Diana.",
              month: null,
              trend: ["80s"],
              type: "image",
            },
            {
              label: "Stranger Things",
              shortLabel: null,
              image: imageObject('moments-searching/strangerthings-02', 'jpg', 1200, 800),
              caption: "Netflix released season 2 of Stranger Things in October, making dressing as a character from the show a popular Halloween costume choice for the second year running. In November Lyst saw thousands of searches for Dustin’s dinosaur hoodie.",
              month: null,
              trend: ["80s"],
              type: "image",
            },
            {
              label: "La La Land",
              shortLabel: null,
              image: imageObject('moments-searching/LaLaLand', 'jpg', 2048, 1365),
              caption: "Released in January, the world went lala for La La Land style. By the time the movie took home 6 Oscars in February- searches for yellow dresses had increased 18%.",
              month: null,
              trend: null,
              type: "image",
            },
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "The World Went Crazy for These Cult Instagram Items",
          navHeading: "Insta-Hits",
          intro: "<p>What makes an Insta-cult fashion item? Immediately recognisable, seen on every influencer, liked by millions and wanted worldwide. Here’s the 10 most searched for Insta-hits of the year.</p>",
          items: [
            {
              label: "Gucci Logo T-shirt",
              shortLabel: null,
              image: imageObject('insta/insta-1', 'jpg', 800, 992),
              caption: "As seen on Rihanna, Hailey Baldwin, Sofia Richie.",
              month: "April",
              trend: ["Logo","Gucci-ish","Streetwear"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BS9PS0ODWDy/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:50.0% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BS9PS0ODWDy/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">phresh out.</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by badgalriri (@badgalriri) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-04-16T18:48:39+00:00">Apr 16, 2017 at 11:48am PDT</time></p></div></blockquote>`,
            },
            {
              label: "Gucci GG Belt",
              shortLabel: null,
              image: imageObject('insta/insta-2', 'jpg', 800, 1264),
              caption: "As seen on Rosie Huntington-Whiteley, Olivia Munn, Lucy Hale.",
              month: "May",
              trend: ["Logo","Gucci-ish"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BYltRAQgiVS/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:62.5% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BYltRAQgiVS/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">Lazy shirt and jeans kind of Sunday chilling on the couch with my book ❤️ Would love some recommendations, I&#39;ve been flying through a book a week recently and I&#39;m running out of decent options. Stripe crop top from @rebelliousfashion use code emmazoey15 ❤️❤️</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by Emma Roche (@emmazoeyroche) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-09-03T18:37:08+00:00">Sep 3, 2017 at 11:37am PDT</time></p></div></blockquote>`,
            },
            {
              label: "Balenciaga ‘Bernie’ Logo Sweatshirt",
              shortLabel: null,
              image: imageObject('insta/insta-3', 'jpg', 800, 1016),
              caption: "As seen on Nick Jonas, Chiara Ferragni, Hyuna.",
              month: "February",
              trend: ["Logo","Woke"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BaWQu54gBQF/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:50.0% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BXbCNSLFwXx/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">morning 💙 wearing my new TWENTY Matte Lip from the #birthdaycollection available right now KylieCosmetics.com</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by Kylie (@kyliejenner) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-08-05T18:37:06+00:00">Aug 5, 2017 at 11:37am PDT</time></p></div></blockquote>`,
            },
            {
              label: "Cult Gaia Ark Bags",
              shortLabel: null,
              image: imageObject('insta/insta-4', 'jpg', 800, 1192),
              caption: "As Seen On Danielle Bernstein, Rocky Barnes, Michelle Williams.",
              month: "August",
              trend: ["Jetleisure"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BWYL5XjgLGS/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:62.5% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BWYL5XjgLGS/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">no 🚫 zone</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by Danielle Bernstein (@weworewhat) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-07-10T19:32:38+00:00">Jul 10, 2017 at 12:32pm PDT</time></p></div></blockquote>`,
            },
            {
              label: "Lisa Marie Fernandez Swimwear",
              shortLabel: null,
              image: imageObject('insta/insta-5', 'jpg', 800, 1075),
              caption: "As Seen On Kendall Jenner, Princess Maria-Olympia of Greece, Lucy Williams.",
              month: "June",
              trend: ["Jetleisure"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BUeZiJyjXtS/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:55.23148148148148% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BUeZiJyjXtS/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">🌸</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by Kendall (@kendalljenner) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-05-24T12:24:28+00:00">May 24, 2017 at 5:24am PDT</time></p></div></blockquote>`,
            },
            {
              label: "Le Specs x Adam Selman Lolita Sunglasses",
              shortLabel: null,
              image: imageObject('insta/insta-6', 'jpg', 800, 1190),
              caption: "As Seen On Zoe Kravitz, Kourtney Kardashian, Gigi Hadid.",
              month: "July",
              trend: ["Jetleisure"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BH-boScD0Ld/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:62.4537037037037% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BH-boScD0Ld/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">🏎🚗🚒</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by Gigi Hadid (@gigihadid) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2016-07-17T20:10:21+00:00">Jul 17, 2016 at 1:10pm PDT</time></p></div></blockquote>`,
            },
            {
              label: "Rejina Pyo Puff Sleeve Dress",
              shortLabel: null,
              image: imageObject('insta/insta-7', 'jpg', 800, 1016),
              caption: "As Seen On Kate Foley, Veronika Heilbrunner, Jan Quammie. ",
              month: "September",
              trend: ["Deconstructed"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BZBWitZnMT1/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:50.0% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BZBWitZnMT1/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">Yes mum, I m always looking left before crossing streets! ✅ Thanks for the moment #CaroladeArmas #pinkbyheilbrunner</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by Veronika Heilbrunner (@veronikaheilbrunner) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-09-14T12:17:19+00:00">Sep 14, 2017 at 5:17am PDT</time></p></div></blockquote>`,
            },
            {
              label: "RE/DONE Patchwork Jeans",
              shortLabel: null,
              image: imageObject('insta/insta-8', 'jpg', 800, 1190),
              caption: "As Seen On Alessandra Ambrosio, Lily-Rose Depp, Selena Gomez. ",
              month: "October",
              trend: ["Deconstructed"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BUNO8xbhAt7/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:62.487462387161486% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BUNO8xbhAt7/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">RE/DONE jeans + RE/DONE tee is always a good look #shopredone</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by RE/DONE (@shopredone) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-05-17T20:24:53+00:00">May 17, 2017 at 1:24pm PDT</time></p></div></blockquote>`,
            },
            {
              label: "Ganni Croissant T-shirt",
              shortLabel: null,
              image: imageObject('insta/insta-9', 'jpg', 800, 1263),
              caption: "As Seen On Camille Charriere, Pernille Teisbaek, Blanca Miró Scrimieri.",
              month: "July",
              trend: null,
              type: "image",
              instaLink: "https://www.instagram.com/p/BYAl-YHBcVK/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:62.457142857142856% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BYAl-YHBcVK/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">💋 ᴄᴀsᴜᴀʟ sᴜɴᴅᴀʏ ʟᴏᴏᴋ // #wiw #rogervivier #ganni #rogervivierchips #rogerviviersandals #rogerviviershoes #whatiwore #outfitpost #fashiondiaries #rogervivierflats #fashionpost #rvchips #gannigirls #styleblogger #slogantee #guccibelt #gannicroissant #currentelliott #sophiefishslookbook</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by ♔ 蘇菲魚 ♔ (@sophiefishtw) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-08-20T08:41:32+00:00">Aug 20, 2017 at 1:41am PDT</time></p></div></blockquote>`,
            },
            {
              label: "Caroline Constas Tops",
              shortLabel: null,
              image: imageObject('insta/insta-10', 'jpg', 800, 1215),
              caption: "As Seen On Pandora Sykes, Sarah Jessica Parker, Aimee Song.",
              month: "May",
              trend: ["Deconstructed"],
              type: "image",
              instaLink: "https://www.instagram.com/p/BZ8aEkWDYuk/",
              instaEmbed: `<blockquote class="instagram-media" data-instgrm-version="7" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:658px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:8px;"> <div style=" background:#F8F8F8; line-height:0; margin-top:40px; padding:62.5% 0; text-align:center; width:100%;"> <div style=" background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURczMzPf399fX1+bm5mzY9AMAAADiSURBVDjLvZXbEsMgCES5/P8/t9FuRVCRmU73JWlzosgSIIZURCjo/ad+EQJJB4Hv8BFt+IDpQoCx1wjOSBFhh2XssxEIYn3ulI/6MNReE07UIWJEv8UEOWDS88LY97kqyTliJKKtuYBbruAyVh5wOHiXmpi5we58Ek028czwyuQdLKPG1Bkb4NnM+VeAnfHqn1k4+GPT6uGQcvu2h2OVuIf/gWUFyy8OWEpdyZSa3aVCqpVoVvzZZ2VTnn2wU8qzVjDDetO90GSy9mVLqtgYSy231MxrY6I2gGqjrTY0L8fxCxfCBbhWrsYYAAAAAElFTkSuQmCC); display:block; height:44px; margin:0 auto -44px; position:relative; top:-22px; width:44px;"></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a href="https://www.instagram.com/p/BZ8aEkWDYuk/" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank">Magic carpet shopping for the house. So happy to be back in Marrakech. Let the shopping begin...</a></p> <p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">A post shared by Aimee Song (@songofstyle) on <time style=" font-family:Arial,sans-serif; font-size:14px; line-height:17px;" datetime="2017-10-07T10:43:21+00:00">Oct 7, 2017 at 3:43am PDT</time></p></div></blockquote>`,
            }
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "Everyone Invested in It-Kicks",
          navHeading: "It-Kicks",
          intro: "<p>There were more searches for sneakers than handbags this year, with more than 3 million shoppers searching for a pair on Lyst every month. These were the most wanted sneakers of 2017:</p>",
          items: [
            {
              label: "Fenty Puma Bow",
              shortLabel: null,
              image: imageObject('products/sneakers/Fenty-Puma', 'png', 2000, 1200),
              caption: "Rihanna’s magic touch made these the most wanted sneaker of the year. One person searched for these shoes every 7 seconds in March.",
              month: "February",
              trend: null,
              type: "image",
            },
            {
              label: "Balenciaga Speed",
              shortLabel: null,
              image: imageObject('products/sneakers/Balenciaga-Black-Speed-Knit-Sneakers-Lyst', 'png', 581, 352),
              caption: "The Balenciaga Speed sneaker was one the most popular products on Lyst over the fall.",
              month: "July",
              trend: ["Logo","Streetwear"],
              type: "image",
            },
            {
              label: "Gucci Ace",
              shortLabel: null,
              image: imageObject('products/sneakers/Gucci-White-Ace-Embroidered-Low-top-Sneaker-Lyst', 'png', 700, 319),
              caption: "Gucci’s Ace sneaker was a women’s and menswear smash hit.",
              month: "May",
              trend: ["Gucci-ish"],
              type: "image",
            },
            {
              label: "Vans Old Skool",
              shortLabel: null,
              image: imageObject('products/sneakers/Vans-Multicolor-Old-Skool-Sneaker-Lyst', 'png', 986, 500),
              caption: "Searches began to increase for Vans Old Skool in March and were up 48% year on year by July.",
              month: "March",
              trend: ["90s"],
              type: "image",
            },
            {
              label: "Adidas Gazelle",
              shortLabel: null,
              image: imageObject('products/sneakers/Adidas-Originals-Gazelle-Trainers-In-Red-S76228-Lyst', 'png', 633, 283),
              caption: "Adidas’ most wanted sneaker on Lyst.",
              month: "September",
              trend: ["70s"],
              type: "image",
            },
            {
              label: "Comme des Garcons Play",
              shortLabel: null,
              image: imageObject('products/sneakers/Comme-des-Garcons-White-Converse-X-Play-Classic-Sneakers-Lyst', 'png', 637, 241),
              caption: "The sneaker was searched for over 20,000 times in January.",
              month: "January",
              trend: null,
              type: "image",
            },
            {
              label: "Common Projects Achilles",
              shortLabel: null,
              image: imageObject('products/sneakers/Common-Projects-White-Original-Achilles-Sneaker-Lyst', 'png', 700, 500),
              caption: "A unisex favourite, Lyst saw thousands of searches for white Common Projects’ this year.",
              month: "April",
              trend: null,
              type: "image",
            },
            {
              label: "Balenciaga Race Runner",
              shortLabel: null,
              image: imageObject('products/sneakers/Balenciaga-White-Race-Runner-Sneakers-Lyst', 'png', 642, 366),
              caption: "A fashion favourite amongst celebrities and influencers alike.",
              month: "February",
              trend: null,
              type: "image",
            },
            {
              label: "New Balance 990",
              shortLabel: null,
              image: imageObject('products/sneakers/New-Balance-Gray-Womens-990-V4-Running-Shoes-Lyst', 'png', 682, 464),
              caption: "Averaged 10,000 searches a week following their May launch.",
              month: "May",
              trend: null,
              type: "image",
            },
            {
              label: "Nike Air Max 97",
              shortLabel: null,
              image: imageObject('products/sneakers/Nike-Metallic-W-Air-Max-97-Og-Qs-for-Men-Lyst', 'png', 856, 490),
              caption: "A 90s favourite, UK grime artist Skepta helped to bring these back this year.",
              month: "August",
              trend: ["Streetwear"],
              type: "image",
            }
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "You Put an Earring On It",
          navHeading: "Jewelry",
          intro: "<p>Earrings, in all shapes and sizes, were the most wanted jewels of the year. These were the 5 biggest jewelry trends of 2017.</p>",
          items: [
            {
              label: "Tassel Earrings",
              shortLabel: null,
              image: imageObject('products/jewellery/Tassel-earrings', 'png', 381, 606),
              caption: "Tassels started trending in April and remained popular all year round, across price points. Oscar De La Renta’s were the most viewed pair.",
              month: "April",
              trend: ["70s","Deconstructed"],
              type: "image",
            },
            {
              label: "Gold Hoop Earrings",
              shortLabel: null,
              image: imageObject('products/jewellery/Gold-hoops', 'png', 691, 424),
              caption: "A pair of gold hoop earrings was purchased every 3 minutes in 2017.",
              month: "August",
              trend: ["90s","Jetleisure"],
              type: "image",
            },
            {
              label: "Signet Rings",
              shortLabel: null,
              image: imageObject('products/jewellery/Signet-Ring', 'png', 484, 286),
              caption: "Searches for signet rings increased 38% on 2016.",
              month: "June",
              trend: ["80s","90s"],
              type: "image",
            },
            {
              label: "Pearls",
              shortLabel: null,
              image: imageObject('products/jewellery/Pearls-Sophie-Bille-Brahe-Metallic-Lisa-Pave-Band-Lyst', 'png', 573, 381),
              caption: "Pearl rings, necklaces and earrings all saw significant search increases this year.",
              month: "July",
              trend: ["80s"],
              type: "image",
            },
            {
              label: "Artsy Earrings",
              shortLabel: null,
              image: imageObject('products/jewellery/Artsy-earrings-JW-Anderson', 'png', 543, 386),
              caption: "Graphic design pieces by J.W. Anderson and Anissa Kermiche were amongst the most wanted statement earrings.",
              month: "February",
              trend: ["70s","Deconstructed"],
              type: "image",
            },
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "slider",
          heading: "If Rihanna Wore It, You Wanted It",
          navHeading: "Influencers",
          intro: "<p>All Hail Queen Ri, the most powerful celebrity fashion influencer of the year. These ten famous faces drove millions of searches for specific products and designers this year, selling out items in seconds around the world. To name and rank the most influential celebrities in fashion, we monitored the spikes  in  demand created by 50 global superstars during the course of 2017, by looking at search and sales response to some of their most talked-about outfits.</p>",
          items: [
            {
              label: "Rihanna",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Rihanna', 'jpg', 1365, 993),
              caption: "Sent searches soaring for Puma, Off-White, Molly Goddard, Gucci and Raen this year- amongst many more iconic looks that set the fashion world into a frenzy."
            },
            {
              label: "Selena Gomez",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Selena-Gomez', 'jpg', 2048, 2048),
              caption: "With more than 120 million Insta followers, it’s fair to say the world is obsessed with Selena’s style. Coach, Louis Vuitton, Sandy Liang and Rouje all benefitted from the Selena effect this year."
            },
            {
              label: "Bella Hadid",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Bella-Hadid', 'jpg', 1200, 1848),
              caption: "Bella’s long legs sparked thousands of denim searches this year for specialist labels RE/DONE, Ksenia Schnaider and GRLFRND."
            },
            {
              label: "Meghan Markle",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Meghan-Markle', 'jpg', 2896, 1629),
              caption: "Meghan proved her royal style credentials this year, wearing heritage British brands Barbour, Hunter and Burberry. She also spiked searches for lesser known labels Misha Nonoo and Finlay and Co."
            },
            {
              label: "Kate Middleton",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Kate-Middleton', 'jpg', 1280, 1815),
              caption: "Kate continues to spark global demand for her looks- this year caused dresses by Erdem, L.K Bennett, Roland Mouret and Dolce & Gabbana to sell out in seconds."
            },
            {
              label: "Melania Trump",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Melania-Trump-2', 'jpg', 2048, 2048),
              caption: "With all eyes on the new FLOTUS this year, it’s no surprise her fashion choices drove thousands of searches. Melania’s most searched-for looks this year were by European designers Delpozo, Valentino and Dolce & Gabbana."
            },
            {
              label: "A$AP Rocky",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Asap-Rocky', 'jpg', 1548, 1024),
              caption: "The Fashion Killa’s bold Balenciaga, Calvin Klein and Gucci looks all sold out in seconds."
            },
            {
              label: "Harry Styles",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Harry-Styles', 'jpg', 4512, 3292),
              caption: "Harry drove thousands of searches for men’s Gucci floral shirts and suits, wearing the brand throughout his 2017 tour and public appearances."
            },
            {
              label: "Kylie Jenner",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Kylie-Jenner-2', 'jpg', 978, 1163),
              caption: "Overtook Kendall as the most influential of the Kardashian/Jenner clan, based on Lyst’s global search and sales data. Searches spiked for Attico mini dresses, Balenciaga sweats and Tamara Mellon boots after Kylie posted them on her Instagram."
            },
            {
              label: "Emily Ratajkowski",
              shortLabel: null,
              image: imageObject('celebrity-influencers/Emily-Ratjowski', 'jpg', 2550, 2550),
              caption: "The @Emrata effect sent searches soaring for stylish, affordable pieces from Attico, Reformation, Talitha, Hat Attack and Zara."
            },
          ],
        },
        {
          appearsInBody: true,
          appearsInCloud: true,
          type: "editorial",
          heading: "...And Then There Were Unicorns",
          navHeading: "Unicorns",
          intro: "<p>Searches can be surprising. These 5 weird and wonderful trends came from nowhere but made a big impact this year.</p>",
          items: [
            {
              label: "Crazy Denim",
              shortLabel: null,
              image: imageObject('weird-wonderful/Crazy-denim', 'jpg', 1020, 1530),
              caption: "Plastic jeans, mud splattered denim, inside out jeans, jeans with detachable legs, zip up crotches- jeans got obscene in 2017. Topshop’s clear plastic jeans and Vetements x Levis collaboration ‘bare butt’ look were the most searched of the year’s weird and wonderful releases. ",
              month: "September",
              trend: null,
              type: "image",
            },
            {
              label: "Fashion Fruits",
              shortLabel: null,
              image: imageObject('weird-wonderful/Watermelon', 'png', 1036, 500),
              caption: "Fashion searches including the word 'watermelon' increased 140% year on year- peaking in June. Pineapples, cherries, lemons and pumpkins also saw increased search volumes in 2017.",
              month: "July",
              trend: null,
              type: "image",
            },
            {
              label: "Unicorns",
              shortLabel: null,
              image: imageObject('weird-wonderful/Unicorn', 'jpg', 736, 1104),
              caption: "More than 1000 unicorn inspired fashion items were uploaded onto Lyst this year. Unicorn dressing was a popular trend during festival season and demand stayed strong in the run up to Halloween; searches including the word 'unicorn' increased 130% on Lyst from May to October.",
              month: "June",
              trend: null,
              type: "image",
            },
            {
              label: "Extreme Sleeves",
              shortLabel: null,
              image: imageObject('weird-wonderful/Extreme-Sleeves', 'jpg', 1200, 1800),
              caption: "Sleeves replaced shoulders as 2017’s statement body zone. Searches including the word ‘sleeve’ increased 35% over the year- with more than 200,000 searches for specific puff, bell, frill, tulip, tie, balloon and extreme sleeve pieces. The most wanted power sleeve tops and shirts this year were by Jacquemus, Vetements, Zara and Ellery.",
              month: "February",
              trend: null,
              type: "image",
            },
            {
              label: "Lux Socks",
              shortLabel: null,
              image: imageObject('weird-wonderful/Socks', 'jpg', 400, 533),
              caption: "The average cost of a pair of socks increased by 10% this year, thanks to the birth of a new high fashion accessory category. Vetements, Givenchy and Rick Owens reinterpreted the humble tube sock for 2017, and searches spiked for Gucci’s $520 sequin socks in September.",
              month: "November",
              trend: null,
              type: "image",
            }
          ],
        },
        {
          appearsInBody: false,
          appearsInCloud: true,
          type: null,
          heading: "Fashion words",
          navHeading: "Words",
          intro: "<p>To find these fashion words of the year, we analysed text from 6,000 editorial posts, scraped from 10 well-known online fashion magazines from around the world. The articles were broken down into their 1,722,126 component words, and those words were grouped into their unique two-word combinations (bi-grams). We then counted up the most frequently occurring phrases, and used sentiment analysis modelling to build a scale of the most important words of the year.</p>",
          items: [
            {
              label: "Power",
              shortLabel: null,
              image: imageObject('words/Power', 'png', 1131, 330),
              caption: "Lyst analysed text from 6,000 online editorial posts by 10 major fashion publications and found that ‘power’ was one of the most used fashion words of the year.",
              month: null,
              trend: null,
              type: "word",
            },
            {
              label: "Woke",
              shortLabel: null,
              image: imageObject('words/Woke', 'png', 1148, 375),
              caption: "Lyst analysed text from 6,000 online editorial posts by 10 major fashion publications and found that ‘woke’ was one of the most used fashion words of the year.",
              month: null,
              trend: null,
              type: "word",
            },
            {
              label: "Cult",
              shortLabel: null,
              image: imageObject('words/Cult', 'png', 846, 377),
              caption: "Lyst analysed text from 6,000 online editorial posts by 10 major fashion publications and found that ‘cult’ was one of the most used fashion words of the year.",
              month: null,
              trend: null,
              type: "word",
            },
            {
              label: "Millennial",
              shortLabel: null,
              image: imageObject('words/Millennial', 'png', 1175, 226),
              caption: "Lyst analysed text from 6,000 online editorial posts by 10 major fashion publications and found that ‘millennial’ was one of the most used fashion words of the year.",
              month: null,
              trend: null,
              type: "word",
            },
            {
              label: "Ugly",
              shortLabel: null,
              image: imageObject('words/Ugly', 'png', 932, 504),
              caption: "Lyst analysed text from 6,000 online editorial posts by 10 major fashion publications and found that ‘ugly’ was one of the most used fashion words of the year.",
              month: null,
              trend: null,
              type: "word",
            },
          ],
        },
      ],
    },
  },
};

export default data;



// WEBPACK FOOTER //
// ./src/data/index.js